
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.196.53a10.839 10.839 0 0113.067 13.953 10.836 10.836 0 01-4.844 5.902.833.833 0 11-.834-1.444 9.167 9.167 0 003.887-11.45 9.17 9.17 0 10-10.78 12.383l-.281-.283a.833.833 0 111.179-1.179l2 2 .055.062.016.022a.931.931 0 01.057.084l.017.028.016.034.02.044.007.017c.008.02.014.04.02.059a.79.79 0 01.02.078l.003.022a.829.829 0 01.001.272l-.004.03a.433.433 0 01-.015.059.423.423 0 01-.004.018c-.005.02-.013.04-.02.058l-.007.02c-.007.016-.015.03-.021.046l-.015.03-.026.043-.015.026a.457.457 0 01-.03.04l-.02.028a.607.607 0 01-.028.03.285.285 0 01-.027.03l-2 2a.833.833 0 11-1.18-1.178l.738-.738a10.833 10.833 0 01-8.893-9.262A10.842 10.842 0 019.195.531zM12 4.165c.46 0 .834.374.834.833v5.169H16a.834.834 0 010 1.667H12a.834.834 0 01-.834-.833V4.997c0-.46.374-.833.834-.833z","fill-rule":"nonzero"}})])
          )
        }
      }
    